import React from 'react';
import Logo from './Logo.svg';
import './PortalPage.css';

const PortalPage = () => {
  const physicianClick = () => {
    window.location.href = `${process.env.REACT_APP_PHYSICIAN_URL}/calendar`;
  };

  const hospitalClick = () => {
    window.location.href = `${process.env.REACT_APP_HOSPITAL_URL}/calendar`;
  };

  return (
    <div className="mainContainerPortal">
      <div className="centerDiv">
        <div className="logoImage">
          <img src={Logo} alt="" height="60" />
        </div>
        <div className="portalSelectBox">
          <div className="tagLine">Please login as physician or facility to continue.</div>
          <div className="btnBox">
            <div className="physicianPortal">
              <button className="btnStyle" onClick={physicianClick}>
                Physician Portal
              </button>
            </div>
            <div className="hospitalPortal" onClick={hospitalClick}>
              <button className="btnStyle">Facility Portal</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortalPage;
